import { BOOKS, VERSIONS } from "../../utils/constants";
import { Scripture } from "../types";

export const SecondCorinthians: Scripture = {
  version: VERSIONS.KJV,
  book: BOOKS.SECOND_CORINTHIANS,
  chapters: [
    {
      chapter: "1",
      verses: [
        {
          verse: "1",
          text: "Paul, an apostle of Jesus Christ by the will of God, and Timothy our brother, unto the church of God which is at Corinth, with all the saints which are in all Achaia:",
        },
        {
          verse: "2",
          text: "Grace be to you and peace from God our Father, and from the Lord Jesus Christ.",
        },
        {
          verse: "3",
          text: "Blessed be God, even the Father of our Lord Jesus Christ, the Father of mercies, and the God of all comfort;",
        },
        {
          verse: "4",
          text: "Who comforteth us in all our tribulation, that we may be able to comfort them which are in any trouble, by the comfort wherewith we ourselves are comforted of God.",
        },
        {
          verse: "5",
          text: "For as the sufferings of Christ abound in us, so our consolation also aboundeth by Christ.",
        },
        {
          verse: "6",
          text: "And whether we be afflicted, it is for your consolation and salvation, which is effectual in the enduring of the same sufferings which we also suffer: or whether we be comforted, it is for your consolation and salvation.",
        },
        {
          verse: "7",
          text: "And our hope of you is stedfast, knowing, that as ye are partakers of the sufferings, so shall ye be also of the consolation.",
        },
        {
          verse: "8",
          text: "For we would not, brethren, have you ignorant of our trouble which came to us in Asia, that we were pressed out of measure, above strength, insomuch that we despaired even of life:",
        },
        {
          verse: "9",
          text: "But we had the sentence of death in ourselves, that we should not trust in ourselves, but in God which raiseth the dead:",
        },
        {
          verse: "10",
          text: "Who delivered us from so great a death, and doth deliver: in whom we trust that he will yet deliver us;",
        },
        {
          verse: "11",
          text: "Ye also helping together by prayer for us, that for the gift bestowed upon us by the means of many persons thanks may be given by many on our behalf.",
        },
        {
          verse: "12",
          text: "For our rejoicing is this, the testimony of our conscience, that in simplicity and godly sincerity, not with fleshly wisdom, but by the grace of God, we have had our conversation in the world, and more abundantly to you-ward.",
        },
        {
          verse: "13",
          text: "For we write none other things unto you, than what ye read or acknowledge; and I trust ye shall acknowledge even to the end;",
        },
        {
          verse: "14",
          text: "As also ye have acknowledged us in part, that we are your rejoicing, even as ye also are ours in the day of the Lord Jesus.",
        },
        {
          verse: "15",
          text: "And in this confidence I was minded to come unto you before, that ye might have a second benefit;",
        },
        {
          verse: "16",
          text: "And to pass by you into Macedonia, and to come again out of Macedonia unto you, and of you to be brought on my way toward Judaea.",
        },
        {
          verse: "17",
          text: "When I therefore was thus minded, did I use lightness? or the things that I purpose, do I purpose according to the flesh, that with me there should be yea yea, and nay nay?",
        },
        {
          verse: "18",
          text: "But as God is true, our word toward you was not yea and nay.",
        },
        {
          verse: "19",
          text: "For the Son of God, Jesus Christ, who was preached among you by us, even by me and Silvanus and Timotheus, was not yea and nay, but in him was yea.",
        },
        {
          verse: "20",
          text: "For all the promises of God in him are yea, and in him Amen, unto the glory of God by us.",
        },
        {
          verse: "21",
          text: "Now he which stablisheth us with you in Christ, and hath anointed us, is God;",
        },
        {
          verse: "22",
          text: "Who hath also sealed us, and given the earnest of the Spirit in our hearts.",
        },
        {
          verse: "23",
          text: "Moreover I call God for a record upon my soul, that to spare you I came not as yet unto Corinth.",
        },
        {
          verse: "24",
          text: "Not for that we have dominion over your faith, but are helpers of your joy: for by faith ye stand.",
        },
      ],
    },
    {
      chapter: "2",
      verses: [
        {
          verse: "1",
          text: "But I determined this with myself, that I would not come again to you in heaviness.",
        },
        {
          verse: "2",
          text: "For if I make you sorry, who is he then that maketh me glad, but the same which is made sorry by me?",
        },
        {
          verse: "3",
          text: "And I wrote this same unto you, lest, when I came, I should have sorrow from them of whom I ought to rejoice; having confidence in you all, that my joy is the joy of you all.",
        },
        {
          verse: "4",
          text: "For out of much affliction and anguish of heart I wrote unto you with many tears; not that ye should be grieved, but that ye might know the love which I have more abundantly unto you.",
        },
        {
          verse: "5",
          text: "But if any have caused grief, he hath not grieved me, but in part: that I may not overcharge you all.",
        },
        {
          verse: "6",
          text: "Sufficient to such a man is this punishment, which was inflicted of many.",
        },
        {
          verse: "7",
          text: "So that contrariwise ye ought rather to forgive him, and comfort him, lest perhaps such a one should be swallowed up with overmuch sorrow.",
        },
        {
          verse: "8",
          text: "Wherefore I beseech you that ye would confirm your love toward him.",
        },
        {
          verse: "9",
          text: "For to this end also did I write, that I might know the proof of you, whether ye be obedient in all things.",
        },
        {
          verse: "10",
          text: "To whom ye forgive any thing, I forgive also: for if I forgave any thing, to whom I forgave it, for your sakes forgave I it in the person of Christ;",
        },
        {
          verse: "11",
          text: "Lest Satan should get an advantage of us: for we are not ignorant of his devices.",
        },
        {
          verse: "12",
          text: "Furthermore, when I came to Troas to preach Christ\u2019s gospel, and a door was opened unto me of the Lord,",
        },
        {
          verse: "13",
          text: "I had no rest in my spirit, because I found not Titus my brother: but taking my leave of them, I went from thence into Macedonia.",
        },
        {
          verse: "14",
          text: "Now thanks be unto God, which always causeth us to triumph in Christ, and maketh manifest the savour of his knowledge by us in every place.",
        },
        {
          verse: "15",
          text: "For we are unto God a sweet savour of Christ, in them that are saved, and in them that perish:",
        },
        {
          verse: "16",
          text: "To the one we are the savour of death unto death; and to the other the savour of life unto life. And who is sufficient for these things?",
        },
        {
          verse: "17",
          text: "For we are not as many, which corrupt the word of God: but as of sincerity, but as of God, in the sight of God speak we in Christ.",
        },
      ],
    },
    {
      chapter: "3",
      verses: [
        {
          verse: "1",
          text: "Do we begin again to commend ourselves? or need we, as some others, epistles of commendation to you, or letters of commendation from you?",
        },
        {
          verse: "2",
          text: "Ye are our epistle written in our hearts, known and read of all men:",
        },
        {
          verse: "3",
          text: "Forasmuch as ye are manifestly declared to be the epistle of Christ ministered by us, written not with ink, but with the Spirit of the living God; not in tables of stone, but in fleshy tables of the heart.",
        },
        {
          verse: "4",
          text: "And such trust have we through Christ to God-ward:",
        },
        {
          verse: "5",
          text: "Not that we are sufficient of ourselves to think any thing as of ourselves; but our sufficiency is of God;",
        },
        {
          verse: "6",
          text: "Who also hath made us able ministers of the new testament; not of the letter, but of the spirit: for the letter killeth, but the spirit giveth life.",
        },
        {
          verse: "7",
          text: "But if the ministration of death, written and engraven in stones, was glorious, so that the children of Israel could not stedfastly behold the face of Moses for the glory of his countenance; which glory was to be done away:",
        },
        {
          verse: "8",
          text: "How shall not the ministration of the spirit be rather glorious?",
        },
        {
          verse: "9",
          text: "For if the ministration of condemnation be glory, much more doth the ministration of righteousness exceed in glory.",
        },
        {
          verse: "10",
          text: "For even that which was made glorious had no glory in this respect, by reason of the glory that excelleth.",
        },
        {
          verse: "11",
          text: "For if that which is done away was glorious, much more that which remaineth is glorious.",
        },
        {
          verse: "12",
          text: "Seeing then that we have such hope, we use great plainness of speech:",
        },
        {
          verse: "13",
          text: "And not as Moses, which put a vail over his face, that the children of Israel could not stedfastly look to the end of that which is abolished:",
        },
        {
          verse: "14",
          text: "But their minds were blinded: for until this day remaineth the same vail untaken away in the reading of the old testament; which vail is done away in Christ.",
        },
        {
          verse: "15",
          text: "But even unto this day, when Moses is read, the vail is upon their heart.",
        },
        {
          verse: "16",
          text: "Nevertheless when it shall turn to the Lord, the vail shall be taken away.",
        },
        {
          verse: "17",
          text: "Now the Lord is that Spirit: and where the Spirit of the Lord is, there is liberty.",
        },
        {
          verse: "18",
          text: "But we all, with open face beholding as in a glass the glory of the Lord, are changed into the same image from glory to glory, even as by the Spirit of the LORD.",
        },
      ],
    },
    {
      chapter: "4",
      verses: [
        {
          verse: "1",
          text: "Therefore seeing we have this ministry, as we have received mercy, we faint not;",
        },
        {
          verse: "2",
          text: "But have renounced the hidden things of dishonesty, not walking in craftiness, nor handling the word of God deceitfully; but by manifestation of the truth commending ourselves to every man\u2019s conscience in the sight of God.",
        },
        {
          verse: "3",
          text: "But if our gospel be hid, it is hid to them that are lost:",
        },
        {
          verse: "4",
          text: "In whom the god of this world hath blinded the minds of them which believe not, lest the light of the glorious gospel of Christ, who is the image of God, should shine unto them.",
        },
        {
          verse: "5",
          text: "For we preach not ourselves, but Christ Jesus the Lord; and ourselves your servants for Jesus\u2019 sake.",
        },
        {
          verse: "6",
          text: "For God, who commanded the light to shine out of darkness, hath shined in our hearts, to give the light of the knowledge of the glory of God in the face of Jesus Christ.",
        },
        {
          verse: "7",
          text: "But we have this treasure in earthen vessels, that the excellency of the power may be of God, and not of us.",
        },
        {
          verse: "8",
          text: "We are troubled on every side, yet not distressed; we are perplexed, but not in despair;",
        },
        {
          verse: "9",
          text: "Persecuted, but not forsaken; cast down, but not destroyed;",
        },
        {
          verse: "10",
          text: "Always bearing about in the body the dying of the Lord Jesus, that the life also of Jesus might be made manifest in our body.",
        },
        {
          verse: "11",
          text: "For we which live are alway delivered unto death for Jesus\u2019 sake, that the life also of Jesus might be made manifest in our mortal flesh.",
        },
        { verse: "12", text: "So then death worketh in us, but life in you." },
        {
          verse: "13",
          text: "We having the same spirit of faith, according as it is written, I believed, and therefore have I spoken; we also believe, and therefore speak;",
        },
        {
          verse: "14",
          text: "Knowing that he which raised up the Lord Jesus shall raise up us also by Jesus, and shall present us with you.",
        },
        {
          verse: "15",
          text: "For all things are for your sakes, that the abundant grace might through the thanksgiving of many redound to the glory of God.",
        },
        {
          verse: "16",
          text: "For which cause we faint not; but though our outward man perish, yet the inward man is renewed day by day.",
        },
        {
          verse: "17",
          text: "For our light affliction, which is but for a moment, worketh for us a far more exceeding and eternal weight of glory;",
        },
        {
          verse: "18",
          text: "While we look not at the things which are seen, but at the things which are not seen: for the things which are seen are temporal; but the things which are not seen are eternal.",
        },
      ],
    },
    {
      chapter: "5",
      verses: [
        {
          verse: "1",
          text: "For we know that if our earthly house of this tabernacle were dissolved, we have a building of God, an house not made with hands, eternal in the heavens.",
        },
        {
          verse: "2",
          text: "For in this we groan, earnestly desiring to be clothed upon with our house which is from heaven:",
        },
        {
          verse: "3",
          text: "If so be that being clothed we shall not be found naked.",
        },
        {
          verse: "4",
          text: "For we that are in this tabernacle do groan, being burdened: not for that we would be unclothed, but clothed upon, that mortality might be swallowed up of life.",
        },
        {
          verse: "5",
          text: "Now he that hath wrought us for the selfsame thing is God, who also hath given unto us the earnest of the Spirit.",
        },
        {
          verse: "6",
          text: "Therefore we are always confident, knowing that, whilst we are at home in the body, we are absent from the Lord:",
        },
        { verse: "7", text: "(For we walk by faith, not by sight:)" },
        {
          verse: "8",
          text: "We are confident, I say, and willing rather to be absent from the body, and to be present with the Lord.",
        },
        {
          verse: "9",
          text: "Wherefore we labour, that, whether present or absent, we may be accepted of him.",
        },
        {
          verse: "10",
          text: "For we must all appear before the judgment seat of Christ; that every one may receive the things done in his body, according to that he hath done, whether it be good or bad.",
        },
        {
          verse: "11",
          text: "Knowing therefore the terror of the Lord, we persuade men; but we are made manifest unto God; and I trust also are made manifest in your consciences.",
        },
        {
          verse: "12",
          text: "For we commend not ourselves again unto you, but give you occasion to glory on our behalf, that ye may have somewhat to answer them which glory in appearance, and not in heart.",
        },
        {
          verse: "13",
          text: "For whether we be beside ourselves, it is to God: or whether we be sober, it is for your cause.",
        },
        {
          verse: "14",
          text: "For the love of Christ constraineth us; because we thus judge, that if one died for all, then were all dead:",
        },
        {
          verse: "15",
          text: "And that he died for all, that they which live should not henceforth live unto themselves, but unto him which died for them, and rose again.",
        },
        {
          verse: "16",
          text: "Wherefore henceforth know we no man after the flesh: yea, though we have known Christ after the flesh, yet now henceforth know we him no more.",
        },
        {
          verse: "17",
          text: "Therefore if any man be in Christ, he is a new creature: old things are passed away; behold, all things are become new.",
        },
        {
          verse: "18",
          text: "And all things are of God, who hath reconciled us to himself by Jesus Christ, and hath given to us the ministry of reconciliation;",
        },
        {
          verse: "19",
          text: "To wit, that God was in Christ, reconciling the world unto himself, not imputing their trespasses unto them; and hath committed unto us the word of reconciliation.",
        },
        {
          verse: "20",
          text: "Now then we are ambassadors for Christ, as though God did beseech you by us: we pray you in Christ\u2019s stead, be ye reconciled to God.",
        },
        {
          verse: "21",
          text: "For he hath made him to be sin for us, who knew no sin; that we might be made the righteousness of God in him.",
        },
      ],
    },
    {
      chapter: "6",
      verses: [
        {
          verse: "1",
          text: "We then, as workers together with him, beseech you also that ye receive not the grace of God in vain.",
        },
        {
          verse: "2",
          text: "(For he saith, I have heard thee in a time accepted, and in the day of salvation have I succoured thee: behold, now is the accepted time; behold, now is the day of salvation.)",
        },
        {
          verse: "3",
          text: "Giving no offence in any thing, that the ministry be not blamed:",
        },
        {
          verse: "4",
          text: "But in all things approving ourselves as the ministers of God, in much patience, in afflictions, in necessities, in distresses,",
        },
        {
          verse: "5",
          text: "In stripes, in imprisonments, in tumults, in labours, in watchings, in fastings;",
        },
        {
          verse: "6",
          text: "By pureness, by knowledge, by longsuffering, by kindness, by the Holy Ghost, by love unfeigned,",
        },
        {
          verse: "7",
          text: "By the word of truth, by the power of God, by the armour of righteousness on the right hand and on the left,",
        },
        {
          verse: "8",
          text: "By honour and dishonour, by evil report and good report: as deceivers, and yet true;",
        },
        {
          verse: "9",
          text: "As unknown, and yet well known; as dying, and, behold, we live; as chastened, and not killed;",
        },
        {
          verse: "10",
          text: "As sorrowful, yet alway rejoicing; as poor, yet making many rich; as having nothing, and yet possessing all things.",
        },
        {
          verse: "11",
          text: "O ye Corinthians, our mouth is open unto you, our heart is enlarged.",
        },
        {
          verse: "12",
          text: "Ye are not straitened in us, but ye are straitened in your own bowels.",
        },
        {
          verse: "13",
          text: "Now for a recompence in the same, (I speak as unto my children,) be ye also enlarged.",
        },
        {
          verse: "14",
          text: "Be ye not unequally yoked together with unbelievers: for what fellowship hath righteousness with unrighteousness? and what communion hath light with darkness?",
        },
        {
          verse: "15",
          text: "And what concord hath Christ with Belial? or what part hath he that believeth with an infidel?",
        },
        {
          verse: "16",
          text: "And what agreement hath the temple of God with idols? for ye are the temple of the living God; as God hath said, I will dwell in them, and walk in them; and I will be their God, and they shall be my people.",
        },
        {
          verse: "17",
          text: "Wherefore come out from among them, and be ye separate, saith the Lord, and touch not the unclean thing; and I will receive you,",
        },
        {
          verse: "18",
          text: "And will be a Father unto you, and ye shall be my sons and daughters, saith the Lord Almighty.",
        },
      ],
    },
    {
      chapter: "7",
      verses: [
        {
          verse: "1",
          text: "Having therefore these promises, dearly beloved, let us cleanse ourselves from all filthiness of the flesh and spirit, perfecting holiness in the fear of God.",
        },
        {
          verse: "2",
          text: "Receive us; we have wronged no man, we have corrupted no man, we have defrauded no man.",
        },
        {
          verse: "3",
          text: "I speak not this to condemn you: for I have said before, that ye are in our hearts to die and live with you.",
        },
        {
          verse: "4",
          text: "Great is my boldness of speech toward you, great is my glorying of you: I am filled with comfort, I am exceeding joyful in all our tribulation.",
        },
        {
          verse: "5",
          text: "For, when we were come into Macedonia, our flesh had no rest, but we were troubled on every side; without were fightings, within were fears.",
        },
        {
          verse: "6",
          text: "Nevertheless God, that comforteth those that are cast down, comforted us by the coming of Titus;",
        },
        {
          verse: "7",
          text: "And not by his coming only, but by the consolation wherewith he was comforted in you, when he told us your earnest desire, your mourning, your fervent mind toward me; so that I rejoiced the more.",
        },
        {
          verse: "8",
          text: "For though I made you sorry with a letter, I do not repent, though I did repent: for I perceive that the same epistle hath made you sorry, though it were but for a season.",
        },
        {
          verse: "9",
          text: "Now I rejoice, not that ye were made sorry, but that ye sorrowed to repentance: for ye were made sorry after a godly manner, that ye might receive damage by us in nothing.",
        },
        {
          verse: "10",
          text: "For godly sorrow worketh repentance to salvation not to be repented of: but the sorrow of the world worketh death.",
        },
        {
          verse: "11",
          text: "For behold this selfsame thing, that ye sorrowed after a godly sort, what carefulness it wrought in you, yea, what clearing of yourselves, yea, what indignation, yea, what fear, yea, what vehement desire, yea, what zeal, yea, what revenge! In all things ye have approved yourselves to be clear in this matter.",
        },
        {
          verse: "12",
          text: "Wherefore, though I wrote unto you, I did it not for his cause that had done the wrong, nor for his cause that suffered wrong, but that our care for you in the sight of God might appear unto you.",
        },
        {
          verse: "13",
          text: "Therefore we were comforted in your comfort: yea, and exceedingly the more joyed we for the joy of Titus, because his spirit was refreshed by you all.",
        },
        {
          verse: "14",
          text: "For if I have boasted any thing to him of you, I am not ashamed; but as we spake all things to you in truth, even so our boasting, which I made before Titus, is found a truth.",
        },
        {
          verse: "15",
          text: "And his inward affection is more abundant toward you, whilst he remembereth the obedience of you all, how with fear and trembling ye received him.",
        },
        {
          verse: "16",
          text: "I rejoice therefore that I have confidence in you in all things.",
        },
      ],
    },
    {
      chapter: "8",
      verses: [
        {
          verse: "1",
          text: "Moreover, brethren, we do you to wit of the grace of God bestowed on the churches of Macedonia;",
        },
        {
          verse: "2",
          text: "How that in a great trial of affliction the abundance of their joy and their deep poverty abounded unto the riches of their liberality.",
        },
        {
          verse: "3",
          text: "For to their power, I bear record, yea, and beyond their power they were willing of themselves;",
        },
        {
          verse: "4",
          text: "Praying us with much intreaty that we would receive the gift, and take upon us the fellowship of the ministering to the saints.",
        },
        {
          verse: "5",
          text: "And this they did, not as we hoped, but first gave their own selves to the Lord, and unto us by the will of God.",
        },
        {
          verse: "6",
          text: "Insomuch that we desired Titus, that as he had begun, so he would also finish in you the same grace also.",
        },
        {
          verse: "7",
          text: "Therefore, as ye abound in every thing, in faith, and utterance, and knowledge, and in all diligence, and in your love to us, see that ye abound in this grace also.",
        },
        {
          verse: "8",
          text: "I speak not by commandment, but by occasion of the forwardness of others, and to prove the sincerity of your love.",
        },
        {
          verse: "9",
          text: "For ye know the grace of our Lord Jesus Christ, that, though he was rich, yet for your sakes he became poor, that ye through his poverty might be rich.",
        },
        {
          verse: "10",
          text: "And herein I give my advice: for this is expedient for you, who have begun before, not only to do, but also to be forward a year ago.",
        },
        {
          verse: "11",
          text: "Now therefore perform the doing of it; that as there was a readiness to will, so there may be a performance also out of that which ye have.",
        },
        {
          verse: "12",
          text: "For if there be first a willing mind, it is accepted according to that a man hath, and not according to that he hath not.",
        },
        {
          verse: "13",
          text: "For I mean not that other men be eased, and ye burdened:",
        },
        {
          verse: "14",
          text: "But by an equality, that now at this time your abundance may be a supply for their want, that their abundance also may be a supply for your want: that there may be equality:",
        },
        {
          verse: "15",
          text: "As it is written, He that had gathered much had nothing over; and he that had gathered little had no lack.",
        },
        {
          verse: "16",
          text: "But thanks be to God, which put the same earnest care into the heart of Titus for you.",
        },
        {
          verse: "17",
          text: "For indeed he accepted the exhortation; but being more forward, of his own accord he went unto you.",
        },
        {
          verse: "18",
          text: "And we have sent with him the brother, whose praise is in the gospel throughout all the churches;",
        },
        {
          verse: "19",
          text: "And not that only, but who was also chosen of the churches to travel with us with this grace, which is administered by us to the glory of the same Lord, and declaration of your ready mind:",
        },
        {
          verse: "20",
          text: "Avoiding this, that no man should blame us in this abundance which is administered by us:",
        },
        {
          verse: "21",
          text: "Providing for honest things, not only in the sight of the Lord, but also in the sight of men.",
        },
        {
          verse: "22",
          text: "And we have sent with them our brother, whom we have oftentimes proved diligent in many things, but now much more diligent, upon the great confidence which I have in you.",
        },
        {
          verse: "23",
          text: "Whether any do enquire of Titus, he is my partner and fellowhelper concerning you: or our brethren be enquired of, they are the messengers of the churches, and the glory of Christ.",
        },
        {
          verse: "24",
          text: "Wherefore shew ye to them, and before the churches, the proof of your love, and of our boasting on your behalf.",
        },
      ],
    },
    {
      chapter: "9",
      verses: [
        {
          verse: "1",
          text: "For as touching the ministering to the saints, it is superfluous for me to write to you:",
        },
        {
          verse: "2",
          text: "For I know the forwardness of your mind, for which I boast of you to them of Macedonia, that Achaia was ready a year ago; and your zeal hath provoked very many.",
        },
        {
          verse: "3",
          text: "Yet have I sent the brethren, lest our boasting of you should be in vain in this behalf; that, as I said, ye may be ready:",
        },
        {
          verse: "4",
          text: "Lest haply if they of Macedonia come with me, and find you unprepared, we (that we say not, ye) should be ashamed in this same confident boasting.",
        },
        {
          verse: "5",
          text: "Therefore I thought it necessary to exhort the brethren, that they would go before unto you, and make up beforehand your bounty, whereof ye had notice before, that the same might be ready, as a matter of bounty, and not as of covetousness.",
        },
        {
          verse: "6",
          text: "But this I say, He which soweth sparingly shall reap also sparingly; and he which soweth bountifully shall reap also bountifully.",
        },
        {
          verse: "7",
          text: "Every man according as he purposeth in his heart, so let him give; not grudgingly, or of necessity: for God loveth a cheerful giver.",
        },
        {
          verse: "8",
          text: "And God is able to make all grace abound toward you; that ye, always having all sufficiency in all things, may abound to every good work:",
        },
        {
          verse: "9",
          text: "(As it is written, He hath dispersed abroad; he hath given to the poor: his righteousness remaineth for ever.",
        },
        {
          verse: "10",
          text: "Now he that ministereth seed to the sower both minister bread for your food, and multiply your seed sown, and increase the fruits of your righteousness;)",
        },
        {
          verse: "11",
          text: "Being enriched in every thing to all bountifulness, which causeth through us thanksgiving to God.",
        },
        {
          verse: "12",
          text: "For the administration of this service not only supplieth the want of the saints, but is abundant also by many thanksgivings unto God;",
        },
        {
          verse: "13",
          text: "Whiles by the experiment of this ministration they glorify God for your professed subjection unto the gospel of Christ, and for your liberal distribution unto them, and unto all men;",
        },
        {
          verse: "14",
          text: "And by their prayer for you, which long after you for the exceeding grace of God in you.",
        },
        { verse: "15", text: "Thanks be unto God for his unspeakable gift." },
      ],
    },
    {
      chapter: "10",
      verses: [
        {
          verse: "1",
          text: "Now I Paul myself beseech you by the meekness and gentleness of Christ, who in presence am base among you, but being absent am bold toward you:",
        },
        {
          verse: "2",
          text: "But I beseech you, that I may not be bold when I am present with that confidence, wherewith I think to be bold against some, which think of us as if we walked according to the flesh.",
        },
        {
          verse: "3",
          text: "For though we walk in the flesh, we do not war after the flesh:",
        },
        {
          verse: "4",
          text: "(For the weapons of our warfare are not carnal, but mighty through God to the pulling down of strong holds;)",
        },
        {
          verse: "5",
          text: "Casting down imaginations, and every high thing that exalteth itself against the knowledge of God, and bringing into captivity every thought to the obedience of Christ;",
        },
        {
          verse: "6",
          text: "And having in a readiness to revenge all disobedience, when your obedience is fulfilled.",
        },
        {
          verse: "7",
          text: "Do ye look on things after the outward appearance? If any man trust to himself that he is Christ\u2019s, let him of himself think this again, that, as he is Christ\u2019s, even so are we Christ\u2019s.",
        },
        {
          verse: "8",
          text: "For though I should boast somewhat more of our authority, which the Lord hath given us for edification, and not for your destruction, I should not be ashamed:",
        },
        {
          verse: "9",
          text: "That I may not seem as if I would terrify you by letters.",
        },
        {
          verse: "10",
          text: "For his letters, say they, are weighty and powerful; but his bodily presence is weak, and his speech contemptible.",
        },
        {
          verse: "11",
          text: "Let such an one think this, that, such as we are in word by letters when we are absent, such will we be also in deed when we are present.",
        },
        {
          verse: "12",
          text: "For we dare not make ourselves of the number, or compare ourselves with some that commend themselves: but they measuring themselves by themselves, and comparing themselves among themselves, are not wise.",
        },
        {
          verse: "13",
          text: "But we will not boast of things without our measure, but according to the measure of the rule which God hath distributed to us, a measure to reach even unto you.",
        },
        {
          verse: "14",
          text: "For we stretch not ourselves beyond our measure, as though we reached not unto you: for we are come as far as to you also in preaching the gospel of Christ:",
        },
        {
          verse: "15",
          text: "Not boasting of things without our measure, that is, of other men\u2019s labours; but having hope, when your faith is increased, that we shall be enlarged by you according to our rule abundantly,",
        },
        {
          verse: "16",
          text: "To preach the gospel in the regions beyond you, and not to boast in another man\u2019s line of things made ready to our hand.",
        },
        {
          verse: "17",
          text: "But he that glorieth, let him glory in the Lord.",
        },
        {
          verse: "18",
          text: "For not he that commendeth himself is approved, but whom the Lord commendeth.",
        },
      ],
    },
    {
      chapter: "11",
      verses: [
        {
          verse: "1",
          text: "Would to God ye could bear with me a little in my folly: and indeed bear with me.",
        },
        {
          verse: "2",
          text: "For I am jealous over you with godly jealousy: for I have espoused you to one husband, that I may present you as a chaste virgin to Christ.",
        },
        {
          verse: "3",
          text: "But I fear, lest by any means, as the serpent beguiled Eve through his subtilty, so your minds should be corrupted from the simplicity that is in Christ.",
        },
        {
          verse: "4",
          text: "For if he that cometh preacheth another Jesus, whom we have not preached, or if ye receive another spirit, which ye have not received, or another gospel, which ye have not accepted, ye might well bear with him.",
        },
        {
          verse: "5",
          text: "For I suppose I was not a whit behind the very chiefest apostles.",
        },
        {
          verse: "6",
          text: "But though I be rude in speech, yet not in knowledge; but we have been throughly made manifest among you in all things.",
        },
        {
          verse: "7",
          text: "Have I committed an offence in abasing myself that ye might be exalted, because I have preached to you the gospel of God freely?",
        },
        {
          verse: "8",
          text: "I robbed other churches, taking wages of them, to do you service.",
        },
        {
          verse: "9",
          text: "And when I was present with you, and wanted, I was chargeable to no man: for that which was lacking to me the brethren which came from Macedonia supplied: and in all things I have kept myself from being burdensome unto you, and so will I keep myself.",
        },
        {
          verse: "10",
          text: "As the truth of Christ is in me, no man shall stop me of this boasting in the regions of Achaia.",
        },
        {
          verse: "11",
          text: "Wherefore? because I love you not? God knoweth.",
        },
        {
          verse: "12",
          text: "But what I do, that I will do, that I may cut off occasion from them which desire occasion; that wherein they glory, they may be found even as we.",
        },
        {
          verse: "13",
          text: "For such are false apostles, deceitful workers, transforming themselves into the apostles of Christ.",
        },
        {
          verse: "14",
          text: "And no marvel; for Satan himself is transformed into an angel of light.",
        },
        {
          verse: "15",
          text: "Therefore it is no great thing if his ministers also be transformed as the ministers of righteousness; whose end shall be according to their works.",
        },
        {
          verse: "16",
          text: "I say again, Let no man think me a fool; if otherwise, yet as a fool receive me, that I may boast myself a little.",
        },
        {
          verse: "17",
          text: "That which I speak, I speak it not after the Lord, but as it were foolishly, in this confidence of boasting.",
        },
        {
          verse: "18",
          text: "Seeing that many glory after the flesh, I will glory also.",
        },
        {
          verse: "19",
          text: "For ye suffer fools gladly, seeing ye yourselves are wise.",
        },
        {
          verse: "20",
          text: "For ye suffer, if a man bring you into bondage, if a man devour you, if a man take of you, if a man exalt himself, if a man smite you on the face.",
        },
        {
          verse: "21",
          text: "I speak as concerning reproach, as though we had been weak. Howbeit whereinsoever any is bold, (I speak foolishly,) I am bold also.",
        },
        {
          verse: "22",
          text: "Are they Hebrews? so am I. Are they Israelites? so am I. Are they the seed of Abraham? so am I.",
        },
        {
          verse: "23",
          text: "Are they ministers of Christ? (I speak as a fool) I am more; in labours more abundant, in stripes above measure, in prisons more frequent, in deaths oft.",
        },
        {
          verse: "24",
          text: "Of the Jews five times received I forty stripes save one.",
        },
        {
          verse: "25",
          text: "Thrice was I beaten with rods, once was I stoned, thrice I suffered shipwreck, a night and a day I have been in the deep;",
        },
        {
          verse: "26",
          text: "In journeyings often, in perils of waters, in perils of robbers, in perils by mine own countrymen, in perils by the heathen, in perils in the city, in perils in the wilderness, in perils in the sea, in perils among false brethren;",
        },
        {
          verse: "27",
          text: "In weariness and painfulness, in watchings often, in hunger and thirst, in fastings often, in cold and nakedness.",
        },
        {
          verse: "28",
          text: "Beside those things that are without, that which cometh upon me daily, the care of all the churches.",
        },
        {
          verse: "29",
          text: "Who is weak, and I am not weak? who is offended, and I burn not?",
        },
        {
          verse: "30",
          text: "If I must needs glory, I will glory of the things which concern mine infirmities.",
        },
        {
          verse: "31",
          text: "The God and Father of our Lord Jesus Christ, which is blessed for evermore, knoweth that I lie not.",
        },
        {
          verse: "32",
          text: "In Damascus the governor under Aretas the king kept the city of the Damascenes with a garrison, desirous to apprehend me:",
        },
        {
          verse: "33",
          text: "And through a window in a basket was I let down by the wall, and escaped his hands.",
        },
      ],
    },
    {
      chapter: "12",
      verses: [
        {
          verse: "1",
          text: "It is not expedient for me doubtless to glory. I will come to visions and revelations of the Lord.",
        },
        {
          verse: "2",
          text: "I knew a man in Christ above fourteen years ago, (whether in the body, I cannot tell; or whether out of the body, I cannot tell: God knoweth;) such an one caught up to the third heaven.",
        },
        {
          verse: "3",
          text: "And I knew such a man, (whether in the body, or out of the body, I cannot tell: God knoweth;)",
        },
        {
          verse: "4",
          text: "How that he was caught up into paradise, and heard unspeakable words, which it is not lawful for a man to utter.",
        },
        {
          verse: "5",
          text: "Of such an one will I glory: yet of myself I will not glory, but in mine infirmities.",
        },
        {
          verse: "6",
          text: "For though I would desire to glory, I shall not be a fool; for I will say the truth: but now I forbear, lest any man should think of me above that which he seeth me to be, or that he heareth of me.",
        },
        {
          verse: "7",
          text: "And lest I should be exalted above measure through the abundance of the revelations, there was given to me a thorn in the flesh, the messenger of Satan to buffet me, lest I should be exalted above measure.",
        },
        {
          verse: "8",
          text: "For this thing I besought the Lord thrice, that it might depart from me.",
        },
        {
          verse: "9",
          text: "And he said unto me, My grace is sufficient for thee: for my strength is made perfect in weakness. Most gladly therefore will I rather glory in my infirmities, that the power of Christ may rest upon me.",
        },
        {
          verse: "10",
          text: "Therefore I take pleasure in infirmities, in reproaches, in necessities, in persecutions, in distresses for Christ\u2019s sake: for when I am weak, then am I strong.",
        },
        {
          verse: "11",
          text: "I am become a fool in glorying; ye have compelled me: for I ought to have been commended of you: for in nothing am I behind the very chiefest apostles, though I be nothing.",
        },
        {
          verse: "12",
          text: "Truly the signs of an apostle were wrought among you in all patience, in signs, and wonders, and mighty deeds.",
        },
        {
          verse: "13",
          text: "For what is it wherein ye were inferior to other churches, except it be that I myself was not burdensome to you? forgive me this wrong.",
        },
        {
          verse: "14",
          text: "Behold, the third time I am ready to come to you; and I will not be burdensome to you: for I seek not yours, but you: for the children ought not to lay up for the parents, but the parents for the children.",
        },
        {
          verse: "15",
          text: "And I will very gladly spend and be spent for you; though the more abundantly I love you, the less I be loved.",
        },
        {
          verse: "16",
          text: "But be it so, I did not burden you: nevertheless, being crafty, I caught you with guile.",
        },
        {
          verse: "17",
          text: "Did I make a gain of you by any of them whom I sent unto you?",
        },
        {
          verse: "18",
          text: "I desired Titus, and with him I sent a brother. Did Titus make a gain of you? walked we not in the same spirit? walked we not in the same steps?",
        },
        {
          verse: "19",
          text: "Again, think ye that we excuse ourselves unto you? we speak before God in Christ: but we do all things, dearly beloved, for your edifying.",
        },
        {
          verse: "20",
          text: "For I fear, lest, when I come, I shall not find you such as I would, and that I shall be found unto you such as ye would not: lest there be debates, envyings, wraths, strifes, backbitings, whisperings, swellings, tumults:",
        },
        {
          verse: "21",
          text: "And lest, when I come again, my God will humble me among you, and that I shall bewail many which have sinned already, and have not repented of the uncleanness and fornication and lasciviousness which they have committed.",
        },
      ],
    },
    {
      chapter: "13",
      verses: [
        {
          verse: "1",
          text: "This is the third time I am coming to you. In the mouth of two or three witnesses shall every word be established.",
        },
        {
          verse: "2",
          text: "I told you before, and foretell you, as if I were present, the second time; and being absent now I write to them which heretofore have sinned, and to all other, that, if I come again, I will not spare:",
        },
        {
          verse: "3",
          text: "Since ye seek a proof of Christ speaking in me, which to you-ward is not weak, but is mighty in you.",
        },
        {
          verse: "4",
          text: "For though he was crucified through weakness, yet he liveth by the power of God. For we also are weak in him, but we shall live with him by the power of God toward you.",
        },
        {
          verse: "5",
          text: "Examine yourselves, whether ye be in the faith; prove your own selves. Know ye not your own selves, how that Jesus Christ is in you, except ye be reprobates?",
        },
        {
          verse: "6",
          text: "But I trust that ye shall know that we are not reprobates.",
        },
        {
          verse: "7",
          text: "Now I pray to God that ye do no evil; not that we should appear approved, but that ye should do that which is honest, though we be as reprobates.",
        },
        {
          verse: "8",
          text: "For we can do nothing against the truth, but for the truth.",
        },
        {
          verse: "9",
          text: "For we are glad, when we are weak, and ye are strong: and this also we wish, even your perfection.",
        },
        {
          verse: "10",
          text: "Therefore I write these things being absent, lest being present I should use sharpness, according to the power which the Lord hath given me to edification, and not to destruction.",
        },
        {
          verse: "11",
          text: "Finally, brethren, farewell. Be perfect, be of good comfort, be of one mind, live in peace; and the God of love and peace shall be with you.",
        },
        { verse: "12", text: "Greet one another with an holy kiss." },
        { verse: "13", text: "All the saints salute you." },
        {
          verse: "14",
          text: "The grace of the Lord Jesus Christ, and the love of God, and the communion of the Holy Ghost, be with you all. Amen.",
        },
      ],
    },
  ],
};
